import React from 'react';
import VideoMockup from './VideoMockup';

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Spectral glow behind the headline */}
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-10rem] left-1/2 -translate-x-1/2 w-[52rem] h-[32rem] bg-spectral/20 rounded-full blur-[140px]"></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 lg:pt-44 pb-16 lg:pb-24 text-center">

        {/* Context chip */}
        <div className="hero-rise hero-delay-1 inline-flex items-center gap-2 font-mono text-xs text-mist border border-phantom/20 rounded-full px-4 py-1.5 mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-phantom"></span>
          For macOS · 100% offline OCR
        </div>

        {/* Headline: the word "uncopyable" gets captured on load */}
        <h1 className="hero-rise hero-delay-2 font-display font-bold text-bone leading-[1.05] text-5xl sm:text-6xl lg:text-7xl mb-8">
          Copy the{' '}
          <span className="capture-wrap">
            <span className="capture-word">uncopyable</span>
            <span className="capture-box" aria-hidden="true">
              <i className="capture-handle tl"></i>
              <i className="capture-handle tr"></i>
              <i className="capture-handle bl"></i>
              <i className="capture-handle br"></i>
              <span className="capture-chip">⌘C copied</span>
            </span>
          </span>
          .
        </h1>

        <p className="hero-rise hero-delay-3 text-base lg:text-xl text-mist leading-relaxed max-w-2xl mx-auto mb-10">
          Ghost Text is a lightweight macOS app that extracts invisible or unselectable
          text from anywhere on your screen — instantly, privately, and offline.
        </p>

        {/* CTAs */}
        <div className="hero-rise hero-delay-4 flex flex-col sm:flex-row gap-4 justify-center mb-16 lg:mb-20">
          <button
            onClick={() => {
              const link = document.createElement('a');
              link.href = '/Ghost Text.dmg';
              link.download = 'Ghost Text.dmg';
              link.target = '_blank';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
            className="btn-primary text-base"
          >
            Download free trial
          </button>
          <button
            onClick={() => window.open('https://checkout.dodopayments.com/buy/pdt_54TFptJsGToLhXUMmCpdC?quantity=1', '_blank')}
            className="btn-secondary text-base"
          >
            Get lifetime access — $9.99
          </button>
        </div>

        {/* Product video in a mac window */}
        <div className="hero-rise hero-delay-4 max-w-3xl mx-auto">
          <VideoMockup />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
